// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFooterFacebookInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="39" height="39" x=".5" y=".5" fill="#000" stroke="#333" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M24.410219,21 L24.8769246,18.1043749 L21.9588659,18.1043749 L21.9588659,16.2253122 C21.9588659,15.4331245 22.3664947,14.6609373 23.6734014,14.6609373 L25,14.6609373 L25,12.1956253 C25,12.1956253 23.7961493,12 22.6451393,12 C20.2420322,12 18.6712495,13.3868752 18.6712495,15.8975 L18.6712495,18.1043749 L16,18.1043749 L16,21 L18.6712495,21 L18.6712495,28 L21.9588654,28 L21.9588654,21 L24.410219,21 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFooterFacebookInactive);
